import axios from 'axios';
import { API_URL } from "../config/connect";

export const getFilterAnnouncements = async (filters = {}) => {
    try {
        const accessToken = localStorage.getItem("access_token");
        const headers = {};
        
        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        }

        const queryParams = new URLSearchParams();

        if (filters.q) queryParams.append('q', filters.q);
        if (filters.sort_by_date) queryParams.append('sort_by_date', filters.sort_by_date);
        if (filters.sort_by_price) queryParams.append('sort_by_price', filters.sort_by_price);
        if (filters.is_vip !== undefined) queryParams.append('is_vip', filters.is_vip);
        // Only add category_id if it's a valid number (not null, undefined, or 'null')
        if (filters.category_id && filters.category_id !== 'null' && filters.category_id !== null && !isNaN(Number(filters.category_id))) {
            queryParams.append('category_id', filters.category_id);
        }
        // Only add subcategory_id if it's a valid number (not null, undefined, or 'null')
        if (filters.subcategory_id && filters.subcategory_id !== 'null' && filters.subcategory_id !== null && !isNaN(Number(filters.subcategory_id))) {
            queryParams.append('subcategory_id', filters.subcategory_id);
        }

        // New catalog-based location filters (preferred)
        if (filters.country_id && !isNaN(Number(filters.country_id))) {
            queryParams.append('country_id', filters.country_id);
        }
        if (filters.region_id && !isNaN(Number(filters.region_id))) {
            queryParams.append('region_id', filters.region_id);
        }
        if (filters.district_id && !isNaN(Number(filters.district_id))) {
            queryParams.append('district_id', filters.district_id);
        }

        // Legacy text-based location filters (ignored by new backend, kept for backward compatibility)
        if (filters.country) queryParams.append('country', filters.country);
        if (filters.province) queryParams.append('province', filters.province);
        if (filters.locality) queryParams.append('locality', filters.locality);
        if (filters.area) queryParams.append('area', filters.area);
        if (filters.latitude) queryParams.append('latitude', filters.latitude);
        if (filters.longitude) queryParams.append('longitude', filters.longitude);
        if (filters.min_price) queryParams.append('min_price', filters.min_price);
        if (filters.max_price) queryParams.append('max_price', filters.max_price);
        if (filters.negotiable !== undefined) queryParams.append('negotiable', filters.negotiable);
        if (filters.page) queryParams.append('page', filters.page);
        if (filters.limit) queryParams.append('limit', filters.limit);

        const response = await axios.get(`${API_URL}/api/v1/announcements?${queryParams.toString()}`, { headers });
        return response.data;
    } catch (error) {
        console.error('Error fetching filtered announcements:', error);
        throw error;
    }
};